import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import loadVidyard from "../apiLoaders/loadVidyard";
import BasePlayerEmbed from "./BasePlayerEmbed";
import debounce from "lodash/debounce";
import { canPublish } from "../utilities";
import { fireEnd, firePause, firePlay } from "../analytics";
var FIRE_PLAY_DEBOUNCE_TIME = 500;

var VidyardPlayerEmbed = /*#__PURE__*/function (_Component) {
  _inherits(VidyardPlayerEmbed, _Component);

  var _super = _createSuper(VidyardPlayerEmbed);

  function VidyardPlayerEmbed() {
    var _this;

    _classCallCheck(this, VidyardPlayerEmbed);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleFrameReady", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var Vidyard, players, player, metadata, videoMetadata;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.analytics || canPublish())) {
                _context.next = 13;
                break;
              }

              _context.next = 3;
              return loadVidyard();

            case 3:
              Vidyard = _context.sent;
              // eslint-disable-next-line new-cap
              players = new Vidyard.players();
              /**
               * Check to see if this player API instance already exists, does not
               * get removed on player iframe removal.
               */

              player = players[_this.props.videoId];

              if (player) {
                _context.next = 13;
                break;
              }

              player = new Vidyard.player(_this.props.videoId); // eslint-disable-line new-cap

              _context.next = 10;
              return new Promise(function (resolve) {
                player.on("ready", function () {
                  resolve(player.metadata);
                });
              });

            case 10:
              metadata = _context.sent;
              videoMetadata = {
                duration: metadata.length_in_seconds,
                id: _this.props.videoId,
                title: metadata.name,
                type: "Vidyard"
              };
              VidyardPlayerEmbed.addAnalyticsToPlayer(player, videoMetadata, _this.props.analytics);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    return _this;
  }

  _createClass(VidyardPlayerEmbed, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          videoId = _this$props.videoId,
          extra = _objectWithoutProperties(_this$props, ["videoId"]);

      var frameUrl = "//play.vidyard.com/".concat(videoId, ".html?type=inline&autoplay=1");
      return /*#__PURE__*/React.createElement(BasePlayerEmbed, _extends({
        id: "vidyard_iframe_".concat(videoId),
        src: frameUrl,
        onFrameReady: this.handleFrameReady
      }, extra));
    }
  }], [{
    key: "addAnalyticsToPlayer",
    value: function addAnalyticsToPlayer(player, videoMetadata, analytics) {
      // Debounce, because Vidyard tends to fire multiple play events
      player.on("play", debounce(function (currentTime) {
        return firePlay(_objectSpread(_objectSpread({}, videoMetadata), {}, {
          currentTime: currentTime
        }), analytics);
      }, FIRE_PLAY_DEBOUNCE_TIME, {
        leading: true,
        trailing: false
      }));
      player.on("pause", function () {
        return firePause(_objectSpread(_objectSpread({}, videoMetadata), {}, {
          currentTime: player.status.currentTime
        }), analytics);
      });
      player.on("playerComplete", function () {
        return fireEnd(_objectSpread(_objectSpread({}, videoMetadata), {}, {
          currentTime: videoMetadata.duration
        }), analytics);
      });
    }
  }]);

  return VidyardPlayerEmbed;
}(Component);

export default VidyardPlayerEmbed;